import { render } from "./CardRain.vue?vue&type=template&id=f8527e8e&scoped=true"
import script from "./CardRain.vue?vue&type=script&lang=js"
export * from "./CardRain.vue?vue&type=script&lang=js"

import "./CardRain.vue?vue&type=style&index=0&id=f8527e8e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f8527e8e"

export default script